import React from 'react';
import { useAppSelector } from 'store';
import { selectIsCryptoPay } from 'store/slice/paymentsCurrency';
import { WalletPopupContentCryptoPay } from './WalletPopupContentCryptoPay';
import { WalletPopupContent } from './WalletPopupContent';

const WalletPopup = (props) => {
  const isCryptoPay = useAppSelector(selectIsCryptoPay);

  return isCryptoPay ? (
    <WalletPopupContentCryptoPay {...props} />
  ) : (
    <WalletPopupContent {...props} />
  );
};

export default WalletPopup;
